// USER LIST
export const BUSINESS_UNIT_LIST = "BUSINESS_UNIT_LIST";
export const BUSINESS_UNIT_LIST_SUCCESS = "BUSINESS_UNIT_LIST_SUCCESS";
export const BUSINESS_UNIT_LIST_FAIL = "BUSINESS_UNIT_LIST_FAIL";
export const BUSINESS_UNIT_LIST_RESET = "BUSINESS_UNIT_LIST_RESET";
export const BUSINESS_UNIT_LIST_COLUMN = "BUSINESS_UNIT_LIST_COLUMN";

// USER ROLE LIST
export const BUSINESS_UNIT_ROLE_LIST = "BUSINESS_UNIT_ROLE_LIST";
export const BUSINESS_UNIT_ROLE_LIST_SUCCESS = "BUSINESS_UNIT_ROLE_LIST_SUCCESS";
export const BUSINESS_UNIT_ROLE_LIST_FAIL = "BUSINESS_UNIT_ROLE_LIST_FAIL";
export const BUSINESS_UNIT_ROLE_LIST_RESET = "BUSINESS_UNIT_ROLE_LIST_RESET";
export const BUSINESS_UNIT_ROLE_LIST_COLUMN = "BUSINESS_UNIT_ROLE_LIST_COLUMN";

// USER CREATE
export const BUSINESS_UNIT_CREATE = "BUSINESS_UNIT_CREATE";
export const BUSINESS_UNIT_CREATE_SUCCESS = "BUSINESS_UNIT_CREATE_SUCCESS";
export const BUSINESS_UNIT_CREATE_FAIL = "BUSINESS_UNIT_CREATE_FAIL";
export const BUSINESS_UNIT_CREATE_RESET = "BUSINESS_UNIT_CREATE_RESET";

// USER DETAIL
export const BUSINESS_UNIT_DETAIL = "BUSINESS_UNIT_DETAIL";
export const BUSINESS_UNIT_DETAIL_SUCCESS = "BUSINESS_UNIT_DETAIL_SUCCESS";
export const BUSINESS_UNIT_DETAIL_FAIL = "BUSINESS_UNIT_DETAIL_FAIL";
export const BUSINESS_UNIT_DETAIL_RESET = "BUSINESS_UNIT_DETAIL_RESET";

// USER UPDATE
export const BUSINESS_UNIT_UPDATE = "BUSINESS_UNIT_UPDATE";
export const BUSINESS_UNIT_UPDATE_SUCCESS = "BUSINESS_UNIT_UPDATE_SUCCESS";
export const BUSINESS_UNIT_UPDATE_FAIL = "BUSINESS_UNIT_UPDATE_FAIL";
export const BUSINESS_UNIT_UPDATE_RESET = "BUSINESS_UNIT_UPDATE_RESET";

// USER DELETE
export const BUSINESS_UNIT_DELETE = "BUSINESS_UNIT_DELETE";
export const BUSINESS_UNIT_DELETE_SUCCESS = "BUSINESS_UNIT_DELETE_SUCCESS";
export const BUSINESS_UNIT_DELETE_FAIL = "BUSINESS_UNIT_DELETE_FAIL";
export const BUSINESS_UNIT_DELETE_RESET = "BUSINESS_UNIT_DELETE_RESET";

// USER ACTIVE
export const BUSINESS_UNIT_ACTIVE = "BUSINESS_UNIT_ACTIVE";
export const BUSINESS_UNIT_ACTIVE_SUCCESS = "BUSINESS_UNIT_ACTIVE_SUCCESS";
export const BUSINESS_UNIT_ACTIVE_FAIL = "BUSINESS_UNIT_ACTIVE_FAIL";
export const BUSINESS_UNIT_ACTIVE_RESET = "BUSINESS_UNIT_ACTIVE_RESET";

// GET PROVINCES LIST
export const PROVINCES_LIST = "PROVINCE_LIST";
export const PROVINCES_LIST_SUCCESS = "PROVINCE_LIST_SUCCESS";
export const PROVINCES_LIST_FAIL = "PROVINCE_LIST_FAIL";

// GET DISTRICTS LIST
export const DISTRICTS_LIST = "DISTRICTS_LIST";
export const DISTRICTS_LIST_SUCCESS = "DISTRICTS_LIST_SUCCESS";
export const DISTRICTS_LIST_FAIL = "DISTRICTS_LIST_FAIL";

// USER DETAIL CONFIG
export const BUSINESS_UNIT_DETAIL_CONFIG = "BUSINESS_UNIT_DETAIL_CONFIG";
export const BUSINESS_UNIT_DETAIL_CONFIG_SUCCESS = "BUSINESS_UNIT_DETAIL_CONFIG_SUCCESS";
export const BUSINESS_UNIT_DETAIL_CONFIG_FAIL = "BUSINESS_UNIT_DETAIL_CONFIG_FAIL";
export const BUSINESS_UNIT_DETAIL_CONFIG_RESET = "BUSINESS_UNIT_DETAIL_CONFIG_RESET";

// USER CREATE CONFIG
export const BUSINESS_UNIT_CONFIG_CREATE = "BUSINESS_UNIT_CONFIG_CREATE";
export const BUSINESS_UNIT_CONFIG_CREATE_SUCCESS = "BUSINESS_UNIT_CONFIG_CREATE_SUCCESS";
export const BUSINESS_UNIT_CONFIG_CREATE_FAIL = "BUSINESS_UNIT_CONFIG_CREATE_FAIL";
export const BUSINESS_UNIT_CONFIG_CREATE_RESET = "BUSINESS_UNIT_CONFIG_CREATE_RESET";

// USER UPDATE CONFIG
export const BUSINESS_UNIT_CONFIG_UPDATE = "BUSINESS_UNIT_CONFIG_UPDATE";
export const BUSINESS_UNIT_CONFIG_UPDATE_SUCCESS = "BUSINESS_UNIT_CONFIG_UPDATE_SUCCESS";
export const BUSINESS_UNIT_CONFIG_UPDATE_FAIL = "BUSINESS_UNIT_CONFIG_UPDATE_FAIL";
export const BUSINESS_UNIT_CONFIG_UPDATE_RESET = "BUSINESS_UNIT_CONFIG_UPDATE_RESET";

// ADD INDENTIFICATION
export const ADD_IDENTIFICATION = "ADD_IDENTIFICATION";
export const ADD_IDENTIFICATION_SUCCESS = "ADD_IDENTIFICATION_SUCCESS";
export const ADD_IDENTIFICATION_FAIL = "ADD_IDENTIFICATION_FAIL"; 

// GET INDENTIFICATION LIST
export const GET_IDENTIFICATION_LIST = "GET_IDENTIFICATION_LIST";
export const GET_IDENTIFICATION_LIST_SUCCESS = "GET_IDENTIFICATION_LIST_SUCCESS";
export const GET_IDENTIFICATION_LIST_FAIL = "GET_IDENTIFICATION_LIST_FAIL"; 

//LEAVE DETAIL BU
export const LEAVE_DETAIL_BU = "LEAVE_DETAIL_BU";